"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createAC2 = exports.createAC = void 0;
const createAC = (e) => 
// "action arguments wrapper" function
(...args) => 
// dispatch injection
(dispatch) => {
    // finally your code
    // @ts-expect-error
    return e(dispatch, ...args);
};
exports.createAC = createAC;
const createAC2 = (e) => 
// "action arguments wrapper" function
(args1, args2) => 
// dispatch injection
(dispatch) => {
    // finally your code
    // @ts-expect-error
    return e(dispatch, args1, args2);
};
exports.createAC2 = createAC2;
